var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99997 2H14V4H5.99999V5.99978H4V13.9996H2V5.99957H3.99999V3.99978H5.99997V2ZM3.99999 15.9998H5.99997V17.9996H14V15.9996H5.99999V13.9998H3.99999V15.9998ZM14 5.99978H16V13.9996H18V5.99957H16V3.99978H14V5.99978ZM20 18.0004H18V20.0004H20L20 22.0002H22V20.0002H20L20 18.0004ZM16 15.9996H18V17.9996H16V15.9998H14V13.9998H16V15.9996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchM);
export default __webpack_public_path__ + "static/media/search-m.a3416604b14839add66b4fb1f17e0e91.svg";
export { ForwardRef as ReactComponent };